import { createReducer, on } from '@ngrx/store';
import { concat, set, toLower } from 'lodash';
import { QuestionnaireActiveActions } from './active.actions';
import { QUESTIONNAIRE_ACTIVE_DATA } from './active.data';
import {
  QuestionnaireActiveState,
  intialQuestionnaireActiveState,
  questionnaireActiveState
} from './active.state';

export const questionnaireActiveReducer = createReducer(
  questionnaireActiveState,
  on(
    QuestionnaireActiveActions.reset,
    (): QuestionnaireActiveState => intialQuestionnaireActiveState()
  ),
  on(QuestionnaireActiveActions.setForm, (state, { key, value }) => ({
    ...state,
    form: {
      ...state.form,
      ...set(state.form, key, value)
    }
  })),
  on(
    QuestionnaireActiveActions.setUserProfile,
    (state, { value: profile }): QuestionnaireActiveState => {
      let form = {
        ...state.form
      };

      if (profile?.information?.height) {
        form = {
          ...form,
          information: {
            ...form.information,
            height: profile.information.height
          }
        };
      }
      if (profile?.information?.weight) {
        form = {
          ...form,
          information: {
            ...form.information,
            weight: profile.information.weight
          }
        };
      }
      if (profile?.medicalHistory) {
        let valueMedicalHistory = {};
        const medicalHistory = profile.medicalHistory
          .filter(
            (o) =>
              toLower(o.medicalType) !== 'illness' &&
              toLower(o.medicalType) !== 'surgical'
          )
          .map((o) => ({
            name: o.medicalNameEn,
            value: o.medicalNameEn,
            medicalType: o.medicalType || 'DISEASE',
            medicalIsOther: o.medicalIsOther || false
          }));
        if (medicalHistory.length > 0) {
          const selected = [];
          const selectedOthers = [];

          for (const medical of medicalHistory) {
            const found = (
              QUESTIONNAIRE_ACTIVE_DATA.medicalHistory?.options ?? []
            ).find((o) => toLower(o.name) === toLower(medical.name));

            if (found) {
              selected.push(found);
            } else {
              selectedOthers.push(medical);
            }
          }
          valueMedicalHistory = {
            medicalHistory: concat(
              selected.length > 1
                ? selected.filter(({ name }) => toLower(name) !== 'none')
                : selected,
              selectedOthers.length > 0
                ? [
                    {
                      name: selectedOthers.map((o) => o.name).join(', '),
                      value: 'OTHER'
                    }
                  ]
                : []
            )
          };
        }
        form = {
          ...form,
          ...valueMedicalHistory
        };
      }

      return {
        ...state,
        form,
        userProfile: profile
      };
    }
  ),
  on(QuestionnaireActiveActions.setLoading, (state, { key, value }) => ({
    ...state,
    loading: {
      ...state.loading,
      [key]: value
    }
  })),
  on(
    QuestionnaireActiveActions.setSubmissionResponse,
    (state, { response, success, message }) => ({
      ...state,
      submissionResponse: {
        response,
        success,
        message
      }
    })
  )
);
